export const validateTask = (taskData) => {
    const errors = {};

    // Task name validation
    if (!taskData.task || taskData.task.trim() === '') {
        errors.task = 'Task name is required';
    } else if (taskData.task.length > 200) {
        errors.task = 'Task name must be less than 200 characters';
    }

    // Owner validation
    if (!taskData.owner || (typeof taskData.owner === 'object' && !taskData.owner.id) || (typeof taskData.owner === 'string' && taskData.owner.trim() === '')) {
        errors.owner = 'Owner is required';
    } else if (typeof taskData.owner === 'string' && taskData.owner.length > 100) {
        errors.owner = 'Owner name must be less than 100 characters';
    }

    // Due date validation
    if (!taskData.dueDate) {
        errors.dueDate = 'Due date is required';
    }

    // Acceptance criteria validation (optional but with max length)
    if (taskData.acceptanceCriteria && taskData.acceptanceCriteria.length > 1000) {
        errors.acceptanceCriteria = 'Acceptance criteria must be less than 1000 characters';
    }

    return errors;
};

export const sanitizeInput = (input) => {
    if (typeof input !== 'string') return input;
    return input.trim();
};